<div class="card">
    <form class="g-3" name="AdditionForm" (ngSubmit)="Validate(AdditionForm)" #AdditionForm="ngForm" novalidate>
        <div class="card-header">
            Asset Addition
        </div>
        <div class="card-body">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="submit" class="btn btn-primary" ngbTooltip="Get Asset From MaxFinance"
                    [disabled]="isDisabled"><i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'':'Loading...'}}</button>
            </div>

            <div class="row pb-2">
                <div class="col-md-4 px-1">
                    <label class="form-font-label">Purchase Reference No.</label>
                    <input type="text" class="form-control" name="PurchaseRefNo" (keypress)="ValidateInput($event)"
                        maxlength="25" placeholder="Ex. PO-ABC-12345" [(ngModel)]="AssetAdditionDetails.PurchaseRefNo"
                        #PurchaseRefNo="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter PurchaseRefNo !
                    </div>
                </div>
                <div class="col-md-3 px-1">
                    <label class="form-font-label">Purchase Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd mmm yyyy" name="PurchaseDate"
                            [maxDate]="MaxDate.Date" [(ngModel)]="AssetAdditionDetails.PurchaseDateObj" required
                            ngbDatepicker #PurchaseDate="ngbDatepicker" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="PurchaseDate.toggle()"
                            type="button"></button>
                        <div class="invalid-feedback">
                            Please enter purchase date !
                        </div>
                    </div>

                </div>

                <div class="col-md-4">
                    <label class="form-font-label">Attachment</label>
                    <Input id="contained-button-file" (change)="upload($event,'AssetAdditionAttachment')"
                        name="Attachment" accept=".pdf,.jpg,.jpeg,.png" type="file" #Attachment
                        style="display: none;" />

                    <div class="col-12 ImageDiv" ngbTooltip="Only upload .pdf,.jpg,.jpeg,.png .">
                        <div class="upload-icon"
                            *ngIf="AssetAdditionDetails.Attachment == null || AssetAdditionDetails.Attachment == ''"
                            (click)="Attachment.click()">
                            <i class="bi bi-upload"></i>
                            <br />
                            <label>Upload</label>
                        </div>
                        <div ngbDropdown>
                            <label class="AssetImage" id="BasicPhoto"
                                *ngIf="AssetAdditionDetails.Attachment != null && AssetAdditionDetails.Attachment  != ''"
                                ngbDropdownToggle>{{AssetAdditionDetails.Attachment}}</label>
                            <img *ngIf="AssetAdditionDetails.Attachment != null && AssetAdditionDetails.Attachment  != ''"
                                [src]="AssetAdditionDetails.AttachmentUrl" class="AssetImage" ngbDropdownToggle
                                id="BasicPhoto" style="display: none;">

                            <div ngbDropdownMenu aria-labelledby="BasicPhoto">
                                <button ngbDropdownItem type="button"><a [href]="AssetAdditionDetails.AttachmentUrl"
                                        target="_blank"><i class="bi bi-eye me-2"></i>View</a></button>
                                <button ngbDropdownItem type="button" (click)="Attachment.click()"><i
                                        class="bi bi-pencil-square me-2"></i>Edit</button>
                            </div>
                        </div>
                    </div>
                    <div class="invalid-feedback">
                        Please select image !
                    </div>
                </div>

                <!-- <div class="col-md-4 px-1">
                    <label class="form-font-label">Attachment</label>
                    <input class="form-control" type="file" id="formFile" name="Attachment"
                        [(ngModel)]="AssetAdditionDetails.Attachment"
                        (change)="upload($event,'AssetAdditionAttachment')" accept=".pdf,.jpg,.jpeg,.png">
                    <div class="invalid-feedback">
                        Please upload attachment!
                    </div>
                </div> -->
            </div>
            <div class="row pb-2">
                <div class="col-md-4 px-1">
                    <label class="form-font-label">Branch</label>
                    <ng-select name="BranchId" [(ngModel)]="AssetAdditionDetails.BranchId" placeholder="Select Branch"
                        required>
                        <ng-option *ngFor="let branchdetail of Branch"
                            [value]="branchdetail.BranchMasterID">{{branchdetail.BranchName}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select branch !
                    </div>
                </div>
                <div class="col-md-4 px-1">
                    <label class="form-font-label">Vendor Name</label>
                    <input type="text" class="form-control" name="VendorName" placeholder="Ex. Matin"
                        [(ngModel)]="AssetAdditionDetails.VendorName" #VendorName="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter vendor name !
                    </div>
                </div>
                <div class="col-md-2 px-1">
                    <label class="form-font-label">Total Asset Count</label>
                    <input type="number" min="0" class="form-control" name="TotalCount" placeholder="Ex. 10"
                        [(ngModel)]="AssetAdditionDetails.TotalCount" #TotalCount="ngModel" required [min]="1">
                    <div *ngIf="TotalCount.invalid && (TotalCount.dirty || TotalCount.touched)"
                        class="invalid-feedback">
                        <div *ngIf="TotalCount.errors && TotalCount.errors['required']">Total asset count is required.
                        </div>
                        <div *ngIf="TotalCount.errors && TotalCount.errors['min']">Total asset count should be greater
                            than 0.</div>
                    </div>
                </div>
                <div class="col-md-2 px-1 pt-4" *ngIf="IsDisableAdd">
                    <button class="btn btn-primary" type="button" (click)="addRowsToTable()" [disabled]="isDisabled"><i
                            class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="isDisabled"></span>
                        {{!isDisabled?'Add':'Loading...'}}</button>
                </div>
            </div>
            <div class="row" style="overflow-x: auto;">
                <div class="card-body">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered" id="assetaddition">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px; ">#</th>
                                <th scope="col" style="width: 250px; ">Asset</th>
                                <th scope="col" style="width: 200px; ">Asset Number </th>
                                <th scope="col" style="width: 200px;">Serial Number </th>
                                <th scope="col" style="width: 200px;">Manufacturer</th>
                                <th scope="col" style="width: 200px;">Model </th>
                                <th scope="col" style="width: 400px;">Warranty Expiry Date </th>
                                <th scope="col" style="width: 200px;">Cost</th>
                                <th scope="col" style="width: 300px;">Remarks </th>
                                <th scope="col" style="width: 300px;">Description</th>
                                <!-- <th scope="col" style="width: 400px;">Attachment </th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let AssetDetails of TableDatas;let rowData of TableDatas; let i = index">
                                <th scope="row">{{i+1}}</th>

                                <td>

                                    <select class="form-select" aria-label="HolidayTypes" title="HolidayTypes"
                                        name="ESS_AssetMasterID{{i}}" [(ngModel)]="AssetDetails.ESS_AssetMasterID"
                                        #ESS_AssetMasterID="ngModel" required>
                                        <option [value]=null selected>--select--</option>
                                        <option *ngFor="let asset of Asset" [value]="asset.ESS_AssetMasterId"
                                            [selected]="asset.ESS_AssetMasterId === 5">
                                            {{ asset.AssetMasterName }}
                                        </option>
                                    </select>
                                    <!-- <ng-select name="ESS_AssetMasterID{{i}}"   
                                    [(ngModel)]="AssetDetails.ESS_AssetMasterID"  placeholder="Select Asset" required >
                                    <ng-option *ngFor="let Assets of Asset"
                                        [value]="Assets.ESS_AssetMasterId">{{Assets.AssetMasterName}}</ng-option>
                                    </ng-select> -->
                                    <div class="invalid-feedback">
                                        Please select asset !
                                    </div>
                                </td>
                                <td>
                                    <input class="form-control" name="AssetNumber{{i}}" type="text"
                                        #AssetNumber="ngModel" [(ngModel)]="AssetDetails.AssetNumber" required />
                                    <div class="invalid-feedback">
                                        Please enter asset number !
                                    </div>
                                </td>
                                <td>
                                    <input class="form-control" name="SerialNumber{{i}}" type="text"
                                        #SerialNumber="ngModel" [(ngModel)]="AssetDetails.SerialNumber" required />
                                    <div class="invalid-feedback">
                                        Please enter asset serial number !
                                    </div>
                                </td>
                                <td>
                                    <input class="form-control" name="Manufacturer{{i}}" type="text"
                                        #Manufacturer="ngModel" [(ngModel)]="AssetDetails.Manufacturer" />
                                </td>
                                <td>
                                    <input class="form-control" name="Model{{i}}" type="text" #Model="ngModel"
                                        [(ngModel)]="AssetDetails.Model" />
                                </td>
                                <td>
                                    <div class="d-flex">
                                        <input name="WarrantyExpiryDate{{i}}" class="form-control detail"
                                            [minDate]="MinDate.Date" [(ngModel)]="AssetDetails.WarrantyExpiryDateObj"
                                            #WarrantyExpiryDate="ngModel" placeholder="dd mmm yyyy" ngbDatepicker
                                            #ExpiryDate="ngbDatepicker" required />
                                        <button class="btn btn-outline-secondary bi bi-calendar3 detail"
                                            (click)="ExpiryDate.toggle()" type="button"></button>
                                    </div>
                                    <div class="invalid-feedback">
                                        Please select warranty expiry date !
                                    </div>
                                </td>
                                <td>
                                    <input class="form-control" name="Cost{{i}}" type="number" min="1" #Cost="ngModel"
                                        [(ngModel)]="AssetDetails.Cost" required />
                                    <div class="invalid-feedback">
                                        Please enter asset cost !
                                    </div>
                                </td>
                                <td>
                                    <input class="form-control" type="text" name="Remarks{{i}}" #Remarks="ngModel"
                                        [(ngModel)]="AssetDetails.Remarks" />
                                </td>
                                <td>
                                    <textarea class="form-control" name="Description{{i}}" #Description="ngModel"
                                        [(ngModel)]="AssetDetails.Description"></textarea>
                                </td>
                                <!-- <td>
                                    <input class="form-control" #Attachment="ngModel" name="Attachment{{i}}" (change)="handleFileInput($event, i)"  
                                        [(ngModel)]="AssetDetails.Attachment" type="file" accept=".pdf,.jpg,.jpeg,.png">
                                </td> -->

                                <!-- (change)="uploadaAssetDetails($event,'AssetAdditionAttachment')" -->
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>